<template>
  <div class="flex flex-nowrap">
    <MarkerColorGrid :entry="entry" @click="setMarkColor" />
    <ContextButton
      @click="$emit('delete', entry)"
      @mouseenter="hoverToDeleteItem = entry.id"
      @mouseleave="hoverToDeleteItem = null"
    />
  </div>
</template>

<script lang="ts" setup>
import type { IMark } from "~/models/IUserEntry";
import type { ColorPicker } from "~/types/ColorPicker";

const { t } = useI18n();
const props = defineProps<{
  entry: IMark;
}>();

const emit = defineEmits<{
  close: [];
  delete: [IMark];
}>();

const { hoverToDeleteItem } = storeToRefs(useContextMenuHoverDelete());

const { updateEntry } = useEntries();

const toast = useToast();

const setMarkColor = async (color: ColorPicker) => {
  try {
    await updateEntry({ ...props.entry, ...color });
  } catch (_) {
    toast.error(t("legal_text.textEditor.errors.color_could_not_be_changed"));
  }
  emit("close");
};
</script>
